export default "__VITE_ASSET__Bz53VOy7__"